import { ViewBoxEvent } from '@/utils/event';
import { handle, newInvoke } from '../../QTBridge';
import { POPOBridgeEmitter } from '@popo-bridge/web';
import { Platform } from '@/utils/platform';
import { bridgeEventEmitter, webEventEmitter } from '../../eventEmitter';
import { callbackToNative } from '../../callhandle/callbackToNative';

export interface CaptureSourceChangResult {
  width: number;
  height: number;
}
export type CaptureSourceChangHandler = (evt: CaptureSourceChangResult) => void;

export const onCaptureSourceChang = async (cb: CaptureSourceChangHandler) => {
  if (Platform.isPOPO) {
    if (Platform.isPC) {
      return bridgeEventEmitter.addListener('captureSourceChanged', async (data, sessionId) => {
        cb(data as CaptureSourceChangResult);
        callbackToNative({
          status: 1,
          data: {},
          message: '',
          sessionId: sessionId as string,
        });
      });
    } else {
      return POPOBridgeEmitter.addListener(
        'captureSourceChanged',
        async (data: CaptureSourceChangResult) => {
          cb(data);
        }
      );
    }
  } else {
    return webEventEmitter.addListener('captureSourceChanged', (data: CaptureSourceChangResult) => {
      cb(data);
    });
  }
};
